import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import DashBoardLayerOne from "../components/DashBoardLayerOne";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const HomePageOne = () => {
  let activeuser =localStorage.getItem('activeUser');
  activeuser =  JSON.parse(activeuser);
   
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Brow SMart" />
        <ToastContainer></ToastContainer>
         {/* DashBoardLayerOne */}
       
{activeuser.user_type == "customer" ?  <p>Customer Portal</p> :
        <DashBoardLayerOne />
}
      </MasterLayout>
    </>
  );
};

export default HomePageOne;
